/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateItemDto } from '../models/work-create-item-dto';
import { WorkDocument } from '../models/work-document';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkItem } from '../models/work-item';
import { WorkItemRelationNamesEnum } from '../models/work-item-relation-names-enum';
import { WorkItemsOverviewDto } from '../models/work-items-overview-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateItemDto } from '../models/work-update-item-dto';

@Injectable({ providedIn: 'root' })
export class WorkItemsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemsV2ControllerGetOverview()` */
  static readonly ItemsV2ControllerGetOverviewPath = '/v2/items/overview';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerGetOverview()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerGetOverview$Response(
    params?: {
      windowDays?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItemsOverviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerGetOverviewPath, 'get');
    if (params) {
      rb.query('windowDays', params.windowDays, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItemsOverviewDto>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerGetOverview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerGetOverview(
    params?: {
      windowDays?: number;
    },
    context?: HttpContext
  ): Observable<WorkItemsOverviewDto> {
    return this.itemsV2ControllerGetOverview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItemsOverviewDto>): WorkItemsOverviewDto => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerFindAllPaginated()` */
  static readonly ItemsV2ControllerFindAllPaginatedPath = '/v2/items';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by productgroupId query param.
     *           <p>
     *              <b>Format: </b> filter.productgroupId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.productgroupId=$not:$like:John Doe&filter.productgroupId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.productgroupId'?: Array<string>;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> calculationitemsCount:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>vendor.company</li>
     * <li>productgroup.name</li>
     * <li>orderNumber</li>
     * <li>calculationitemsCount</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'vendor.company:ASC' | 'vendor.company:DESC' | 'productgroup.name:ASC' | 'productgroup.name:DESC' | 'orderNumber:ASC' | 'orderNumber:DESC' | 'calculationitemsCount:ASC' | 'calculationitemsCount:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,vendor.company,productgroup.name,orderNumber
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>vendor.company</li>
     * <li>productgroup.name</li>
     * <li>orderNumber</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'productgroupId'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.productgroupId', params['filter.productgroupId'], {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkItem>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'productgroupId'?: (string | Array<string>);
        'containertypeId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by productgroupId query param.
     *           <p>
     *              <b>Format: </b> filter.productgroupId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.productgroupId=$not:$like:John Doe&filter.productgroupId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.productgroupId'?: Array<string>;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> calculationitemsCount:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>vendor.company</li>
     * <li>productgroup.name</li>
     * <li>orderNumber</li>
     * <li>calculationitemsCount</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'vendor.company:ASC' | 'vendor.company:DESC' | 'productgroup.name:ASC' | 'productgroup.name:DESC' | 'orderNumber:ASC' | 'orderNumber:DESC' | 'calculationitemsCount:ASC' | 'calculationitemsCount:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,vendor.company,productgroup.name,orderNumber
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>vendor.company</li>
     * <li>productgroup.name</li>
     * <li>orderNumber</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'productgroupId'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
}> {
    return this.itemsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'productgroupId'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'productgroupId'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerCreate()` */
  static readonly ItemsV2ControllerCreatePath = '/v2/items';

  /**
   * Required permissions: items:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemsV2ControllerCreate$Response(
    params: {
      body: WorkCreateItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * Required permissions: items:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemsV2ControllerCreate(
    params: {
      body: WorkCreateItemDto
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.itemsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerFindOneById()` */
  static readonly ItemsV2ControllerFindOneByIdPath = '/v2/items/{id}';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerFindOneById$Response(
    params: {
      id: number;
      relations?: Array<WorkItemRelationNamesEnum>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('relations', params.relations, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerFindOneById(
    params: {
      id: number;
      relations?: Array<WorkItemRelationNamesEnum>;
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.itemsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerDelete()` */
  static readonly ItemsV2ControllerDeletePath = '/v2/items/{id}';

  /**
   * Required permissions: items:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: items:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.itemsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerUpdate()` */
  static readonly ItemsV2ControllerUpdatePath = '/v2/items/{id}';

  /**
   * Required permissions: items:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * Required permissions: items:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  itemsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateItemDto
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.itemsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerGetDocumentsByItemId()` */
  static readonly ItemsV2ControllerGetDocumentsByItemIdPath = '/v2/items/{id}/documents';

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerGetDocumentsByItemId()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerGetDocumentsByItemId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerGetDocumentsByItemIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: items:read, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerGetDocumentsByItemId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerGetDocumentsByItemId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.itemsV2ControllerGetDocumentsByItemId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerGetDropdownOptionsTypes()` */
  static readonly ItemsV2ControllerGetDropdownOptionsTypesPath = '/v2/items/dropdown-options/types';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerGetDropdownOptionsTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerGetDropdownOptionsTypes$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerGetDropdownOptionsTypesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerGetDropdownOptionsTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerGetDropdownOptionsTypes(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.itemsV2ControllerGetDropdownOptionsTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerAddDocumentToItem()` */
  static readonly ItemsV2ControllerAddDocumentToItemPath = '/v2/items/{id}/documents/{documentId}';

  /**
   * Required permissions: items:update, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerAddDocumentToItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerAddDocumentToItem$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerAddDocumentToItemPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Required permissions: items:update, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerAddDocumentToItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerAddDocumentToItem(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.itemsV2ControllerAddDocumentToItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `itemsV2ControllerRemoveDocumentFromItem()` */
  static readonly ItemsV2ControllerRemoveDocumentFromItemPath = '/v2/items/{id}/documents/{documentId}';

  /**
   * Required permissions: items:update, items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemsV2ControllerRemoveDocumentFromItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerRemoveDocumentFromItem$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkItemsV2Service.ItemsV2ControllerRemoveDocumentFromItemPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: items:update, items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemsV2ControllerRemoveDocumentFromItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemsV2ControllerRemoveDocumentFromItem(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.itemsV2ControllerRemoveDocumentFromItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
